import { useState } from 'react'
import PresenzeService from '../services/PresenzeService/PresenzeService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const usePresenze = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingPresenze: false,
    isLoadingPresenzeByParams: false,
    isLoadingPresenzaCreating: false,
    isLoadingPresenzaUpdate: false,
    isLoadingPresenzaDelete: false
  });

  const [modalState, setModalState] = useState({
    showModalCreatePresenza: false,
    showModalUpdatePresenza: false
  });

  const getRegistroPresenzeByParams = async (params) => {
    setLoadingState({ ...loadingState, isLoadingPresenzeByParams: true });
    try {
      let obj;
      let response = await PresenzeService.getRegistroPresenzeByParams(params);
      const res = await response.json();
      const totalRecord = response.headers.get('X-Total-Record');
      obj = {
        data: res,
        count: totalRecord
      }
      return obj
    } catch (err) {
      handleError(err)
    } finally {
      setLoadingState({ ...loadingState, isLoadingPresenzeByParams: false });
    }
  }

  const createRegistroPresenze = async (data) => {
    setLoadingState({ ...loadingState, isLoadingPresenzaCreating: true });
    try {
      const response = await PresenzeService.createRegistroPresenze(data);
/*       alertService.success("Presenza assegnata con successo", {autoClose: true}); */
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingPresenzaCreating: false });
    }
  }

  const updateRegistroPresenze = async (data) => {
    setLoadingState({ ...loadingState, isLoadingPresenzaUpdate: true });
    try {
      const response = await PresenzeService.updateRegistroPresenze(data);
/*       alertService.success("Presenza aggiornata con successo", {autoClose: true}); */
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingPresenzaUpdate: false });
    }
  }

  const deleteRegistroPresenze = async (id) => {
    setLoadingState({ ...loadingState, isLoadingPresenzaDelete: true });
    try {
      await PresenzeService.deleteRegistroPresenze(id);
      alertService.success("Presenza eliminata con successo", {autoClose: true});
      return true;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingPresenzaDelete: false });
    }
  }

  return {
    loadingStatePresenze: loadingState,
    modalStatePresenze: modalState,
    setModalStatePresenze: setModalState,
    getRegistroPresenzeByParams,
    createRegistroPresenze,
    updateRegistroPresenze,
    deleteRegistroPresenze
  };      
}

export default usePresenze;
